import { render, staticRenderFns } from "./PuzzlePage.vue?vue&type=template&id=69ad9643&scoped=true&"
import script from "./PuzzlePage.vue?vue&type=script&lang=js&"
export * from "./PuzzlePage.vue?vue&type=script&lang=js&"
import style0 from "./PuzzlePage.vue?vue&type=style&index=0&id=69ad9643&prod&lang=scss&scoped=true&"
import style1 from "./PuzzlePage.vue?vue&type=style&index=1&id=69ad9643&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ad9643",
  null
  
)

export default component.exports